import { FolderCopyOutlined } from "@mui/icons-material";
import { FC } from "react";
import {
  BulkInsertFooter,
  MuiBox,
  MuiButtonTertiary,
  MuiTypography,
} from "../../../../../components";
import PermissionWrapper from "../../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../../helpers/constants";
import { useSiteCore } from "../../../../../hooks/useSiteCore";

import { BulkUploadStatusResponse } from "../../../../bulkCreateProgram/modelsAndSchema/Models";
import { bulkActivitySiteCoreKeys } from "../../../siteCore/SiteCoreKeys";
import { BulkActivityStatusPanel } from "../../bulkActivityStatusPanel/BulkActivityStatusPanel";
import { BulkActivityProcessWrapper } from "./BulkActivityProcess.style";

export interface BulkActivityProcessUploadProps {
  onRefresh: () => void;
  onNewBulkActivity: () => void;
  summaryData: BulkUploadStatusResponse;
  pageId: string;
  handleNavigateBack: () => void;
}

export const BulkActivityProcess: FC<BulkActivityProcessUploadProps> = ({
  onRefresh,
  onNewBulkActivity,
  summaryData,
  pageId,
  handleNavigateBack,
}) => {
  const { useFetchLabel } = useSiteCore();
  const getLabel = useFetchLabel(
    bulkActivitySiteCoreKeys.addBulkActivitySummary,
  );

  const recordStats = {
    total: {
      count: summaryData?.totalRecords,
      label: getLabel(bulkActivitySiteCoreKeys.totalNumberOfRecords),
    },
    processed: {
      count: summaryData?.processedRecords,
      label: getLabel(bulkActivitySiteCoreKeys.processedRecords),
    },
  };

  return (
    <BulkActivityProcessWrapper>
      <MuiBox className="main-container">
        <BulkActivityStatusPanel
          recordStatistics={recordStats}
          processName={summaryData?.processName}
          status={summaryData?.status}
          onRefresh={onRefresh}
        />

        <MuiTypography
          variant="h5Bold"
          component={"p"}
          className="processing-note"
          data-testid={`processing-note`}
        >
          {getLabel(
            bulkActivitySiteCoreKeys.yourParticipantRecordIsProcessingMessage,
          )}
        </MuiTypography>

        <PermissionWrapper permission={MODULE_PERMISSIONS.BULK_INSERT}>
          <MuiBox className="footer-button">
            <MuiButtonTertiary
              onClick={onNewBulkActivity}
              data-testid={"add-new-bulk-activity"}
            >
              <FolderCopyOutlined />
              {getLabel(bulkActivitySiteCoreKeys.addNewBulkLink)}
            </MuiButtonTertiary>
          </MuiBox>
        </PermissionWrapper>
      </MuiBox>
      <BulkInsertFooter
        pageId={pageId}
        showCloseButtonOnly
        handleNavigateBack={handleNavigateBack}
      />
    </BulkActivityProcessWrapper>
  );
};
